var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.upload.description))]),_c('td',[_c('v-progress-linear',{attrs:{"value":_vm.upload.progress,"color":_vm.progressColor,"height":"25"}},[[_vm._v(" "+_vm._s(_vm.progressPercent)+" "+_vm._s(_vm.upload.progressInfo)+" ")]],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }